import React from 'react';

export default () => (<div className='freshAppFooter'/>)